import otherFormsService from "../../services/otherForms";
const getDefaultState = () => {
    return {
    };
};

const state = getDefaultState();

const getters = {
};

const actions = {
    GetPowerApps(st, data) {
        return otherFormsService.GetPowerApps(st.rootState.auth.idToken, data);
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};